export class ShopAdresse {
    constructor() {
        this.firma = "";
        this.ansprechpartner = "";
        this.strasse = "";
        this.plz = "";
        this.ort = "";
        this.iso3166 = "";
        this.isEU = true;
    }
}
export class ShopZahlungsverbindung {
    constructor() {
        this.kontoinhaber = "";
        this.email = "";
        this.iban = "";
        this.nameDerBank = "";
        this.bic = "";
    }
}
export class UserShop {
    constructor() {
        this.shopName = "";
        this.shoplogopath = "";
        this.error = "";
        this.theme = "";
        this.email = "";
        this.telefon = "";
        // this.adresse=new ShopAdresse();
        this.possibleThemes = [];
        this.isFirmaOrJristischePerson = false;
        this.steuerstatus = "";
        this.ustid = "";
        this.zahlungsverbindung = "";
        this.emailToVerify = "";
        this.emailToVerifyCheck = "";
        this.ibanValid = true;
        this.bicValid = true;
    }
}
//# sourceMappingURL=UserShop.js.map